module.exports = __webpack_public_path__ + "776c50019c3e6398ce85bab0102add56.svg";